import { User } from "firebase/auth";
import { apiFetch } from "./client";

export interface GwChallengePlayer {
  id: string;
  name: string;
  club: string;
  clubShort?: string | null;
  nationality: string | null;
}

export interface GwChallengePickRow {
  gameweekId: string;
  gameweekNumber: number;
  gameweekName: string;
  completed: boolean;
  locked: boolean;
  pick: {
    playerId: string;
    player: GwChallengePlayer;
    goals: number | null;
  } | null;
}

export interface GwChallengePicksResponse {
  rows: GwChallengePickRow[];
  usedPlayerIds: string[];
  totalPoints: number;
  rank: number | null;
  memberCount: number;
}

export function getGwChallengePicks(
  user: User,
  leagueId: string,
): Promise<GwChallengePicksResponse> {
  return apiFetch(user, `/leagues/${leagueId}/challenge/picks`);
}

export function saveGwChallengePicks(
  user: User,
  leagueId: string,
  picks: { gameweekId: string; playerId: string | null }[],
): Promise<{ success: boolean }> {
  return apiFetch(user, `/leagues/${leagueId}/challenge/picks`, {
    method: "PUT",
    body: JSON.stringify({ picks }),
  });
}

export interface GwChallengeMemberPicksResponse {
  rows: GwChallengePickRow[];
  totalPoints: number;
  displayName: string;
}

export function getGwChallengeMemberPicks(
  user: User,
  leagueId: string,
  memberId: string,
): Promise<GwChallengeMemberPicksResponse> {
  return apiFetch(user, `/leagues/${leagueId}/challenge/member/${memberId}/picks`);
}
